import {
  LoginData,
  RecoverPasswordData,
  RegisterData,
  ResetPasswordData,
  User,
} from "./auth.model";
import { ActionTypes } from "./auth.actions";
import { Action } from "@ngrx/store";

export interface State {
  user: User;
  isLogged: boolean;
  loginData: LoginData;
  registerData: RegisterData;
  resetPasswordData: ResetPasswordData;
  recoverPasswordData: RecoverPasswordData;
  loading: boolean;
}

export const initialState: State = {
  user: null,
  isLogged: false,
  loginData: new LoginData(),
  registerData: new RegisterData(),
  resetPasswordData: new ResetPasswordData(),
  recoverPasswordData: new RecoverPasswordData(),
  loading: false,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LOGIN:
      return Object.assign({}, state, {
        loginData: action.payload,
        loading: true,
      });
    case ActionTypes.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLogged: true,
        loginData: new LoginData(),
        loading: false,
      });
    case ActionTypes.LOGIN_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.REGISTER:
      return Object.assign({}, state, { loading: true });
    case ActionTypes.REGISTER_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        registerData: new RegisterData(),
      });
    case ActionTypes.REGISTER_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.LOGOUT:
      return Object.assign({}, state, initialState);

    case ActionTypes.RESET_PASSWORD:
      return Object.assign({}, state, {
        resetPasswordData: action.payload,
        loading: true,
      });
    case ActionTypes.RESET_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        resetPasswordData: new ResetPasswordData(),
        loading: false,
      });
    case ActionTypes.RESET_PASSWORD_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.RECOVER_PASSWORD:
      return Object.assign({}, state, {
        recoverPasswordData: action.payload,
        loading: true,
      });
    case ActionTypes.RECOVER_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        recoverPasswordData: new RecoverPasswordData(),
        loading: false,
      });
    case ActionTypes.RECOVER_PASSWORD_FAIL:
      return Object.assign({}, state, { loading: false });

    default:
      return state;
  }
}

export const getCurrentUser = (state: State) => state.user;
export const getIsLogged = (state: State) => state.isLogged;
export const getLoginData = (state: State) => state.loginData;
export const getRegisterData = (state: State) => state.registerData;
export const getResetPasswordData = (state: State) => state.resetPasswordData;
export const getRecoverPasswordData = (state: State) =>
  state.recoverPasswordData;
export const getIsloading = (state: State) => state.loading;



// WEBPACK FOOTER //
// /app/src/app/core/store/auth/auth.reducer.ts